import styled from "styled-components"
//import media from "styled-media-query"

export const Sidebar = styled.aside`
  flex-basis: 55%;
  padding-top: 2.5em;
`
